export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'scDefaultImgUrl',
    width: 150,
    title: '图片',
    align: 'center',
    slots: { default: 'defaultImgUrl' },
  },
  {
    field: 'imageRemarks',
    align: 'left',
    minWidth: 150,
    title: '图片说明',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    align: 'left',
    minWidth: 100,
    title: '修改时间',
    sortable: true,
  },
]
